/**
 * parseListResponse — normalise the various list-response shapes the CRA app
 * has to handle as the backend migrates from legacy Spring Boot to Supabase
 * RPCs.
 *
 * Three shapes observed in production:
 *   1. Bare array + x-total-count header        (legacy Spring Boot prod)
 *   2. { items, total } envelope               (new Supabase RPC, visits-history)
 *   3. { data, pagination: { total } } envelope (new Supabase RPC, dashboard)
 *
 * The "correct" long-term fix is to align the backend on a single contract,
 * but the frontend cannot block on that — users hit blank pages today
 * (TypeError: a.map is not a function). This helper keeps the UI working
 * against any of the three shapes.
 *
 * @param {object} res  axios response { data, headers, status }
 * @returns {{ items: Array, total: number }}
 */
export const parseListResponse = (res) => {
  if (!res) return { items: [], total: 0 };

  const body = res.data;
  const headers = res.headers || {};

  let items = [];
  if (Array.isArray(body)) {
    items = body;
  } else if (Array.isArray(body?.items)) {
    items = body.items;
  } else if (Array.isArray(body?.data)) {
    items = body.data;
  }

  const headerCount = Number(headers["x-total-count"]);
  const fallbackTotal = Number.isFinite(headerCount)
    ? headerCount
    : Number(body?.total ?? body?.pagination?.total ?? items.length);

  return {
    items,
    total: Number.isFinite(fallbackTotal) ? fallbackTotal : items.length,
  };
};
